import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';
import moment from 'moment';

@Injectable()
export class StatService {

	constructor(private firestore: Firestore) {
			console.log('StatService initialization...');
	}

	listDailyStats(){
		return collectionData(query(collection(this.firestore, 'statistics/daily/data'), orderBy('startTime', 'desc'), 
		limit(30)), { idField: 'id' });
	}

	listDailyStatsFrom(from){
		console.log('listDailyStatsFrom:'+from);
		return collectionData(query(collection(this.firestore, 'statistics/daily/data'), where('startTime','>=',from), 
		orderBy('startTime', 'desc')), { idField: 'id' });
	}

	listStatsFromTo(dateTimeDebut, dateTimeFin){
		var start = moment(dateTimeDebut).startOf('day').valueOf();
		var end = moment(dateTimeFin).endOf('day').valueOf();
		return collectionData(query(collection(this.firestore, 'statistics/daily/data'), where("startTime", ">=", start), 
			where("startTime", "<=", end), orderBy('startTime', 'asc')), { idField: 'id' });
	}
	listStatsMonthlyFromTo(year){
		var start = moment(year, 'YYYY').startOf('year').valueOf();
		var end = moment(year, 'YYYY').endOf('year').valueOf();
		return collectionData(query(collection(this.firestore, 'statistics/monthly/data'), where("startTime", ">=", start),
			where("startTime", "<=", end), orderBy('startTime', 'asc')), { idField: 'id' });
	}
}
